export const LIGHTBULB_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g>
            <path d="M9,21 C9,21.55 9.44999995,22 10,22 L14,22 C14.5500001,22 15,21.55 15,21 L15,20 L9,20 L9,21 Z M12,2 C8.13999999,2 5,5.14
            5,9 C5,11.38 6.19,13.47 7.99999999,14.74 L7.99999999,17 C7.99999999,17.55 8.45000003,18 9.00000001,18 L15,18 C15.55,18 16,17.55
            16,17 L16,14.74 C17.81,13.47 19,11.38 19,9 C19,5.14 15.86,2 12,2 Z M14.85,13.1 L13.9999999,13.7 L13.9999999,16 L10.0000001,16
            L10.0000001,13.7 L9.15000005,13.1 C7.80000003,12.16 7,10.63 7,9 C7,6.24 9.23999998,4 12,4 C14.76,4 17,6.24 17,9 C17,10.63
            16.2,12.16 14.85,13.1 Z"/>
        </g>
    </svg>
`;
